import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { FAQ } from "../lib/content";
import { Reveal } from "./Reveal";

export const FaqAccordion = ({ showHeader = true }) => {
  const [open, setOpen] = useState(0);
  return (
    <section data-testid="faq" className="bg-dst-light text-dst-ink py-24 lg:py-32">
      <div className="container-dst grid lg:grid-cols-[0.9fr_1.1fr] gap-16">
        {showHeader && (
          <Reveal>
            <span className="eyebrow text-dst-red">Answers</span>
            <h2 className="mt-4 font-oswald font-700 uppercase tracking-tighter leading-[0.9] text-5xl lg:text-7xl text-dst-navy">
              Frequently<br />Asked<br />Questions
            </h2>
            <p className="mt-6 text-dst-ink/60 max-w-sm">
              Still have questions? Call us at 830-832-9898 — we're happy to help you find the right program.
            </p>
          </Reveal>
        )}
        <div className={showHeader ? "" : "lg:col-span-2 max-w-3xl mx-auto w-full"}>
          {FAQ.map((item, i) => {
            const active = open === i;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div className="border-b border-dst-ink/15">
                  <button
                    data-testid={`faq-item-${i}`}
                    onClick={() => setOpen(active ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  >
                    <span className={`font-oswald uppercase tracking-tight text-xl sm:text-2xl transition-colors ${active ? "text-dst-red" : "text-dst-navy group-hover:text-dst-red"}`}>
                      {item.q}
                    </span>
                    <span className={`shrink-0 w-9 h-9 grid place-items-center transition-colors ${active ? "bg-dst-red text-white" : "bg-dst-navy/10 text-dst-navy"}`}>
                      {active ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {active && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35 }}
                        className="overflow-hidden"
                      >
                        <p className="pb-6 text-dst-ink/70 leading-relaxed max-w-2xl">{item.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
